import { Stack, Tabs, Title } from '@efast_public/fjd-component-library';
import { ERROR_CASE_CLIENT } from '../../shared/utils/Error/ErrorCode';
import { ErrorComponentClient } from '../shared/Error/ErrorComponent';
import { useMemo } from 'react';
import { getToggle, Toggled } from '../shared/Toggled';
import UsersAndRolesSSO from './SettingsTabs/UsersAndRoles/UsersAndRoles_SSO';
import UsersAndRoles from './SettingsTabs/UsersAndRoles/UsersAndRoles';
import FitConnectSettings from './SettingsTabs/Weiterleitung/FitConnectSettings';
import DatamodelSettings from './SettingsTabs/Datamodels/DatamodelsSettings';
import BundIdSettings from './SettingsTabs/BundId/BundId';
import LogoSettings from './SettingsTabs/Logo/LogoSettings';
import FooterlinksSettings from './SettingsTabs/Footerlinks/FooterlinksSettings';
import { useProfile } from '../../shared/hooks/AuthContext';

export default function SettingsPage() {
  const { hasRole } = useProfile();
  const hasGroupAdministration = useMemo(
    () => hasRole('Administration'),
    [hasRole]
  );

  return !hasGroupAdministration ? (
    <div style={{ width: '50rem' }}>
      <ErrorComponentClient errorCase={ERROR_CASE_CLIENT.NOT_AUTHORIZED} />
    </div>
  ) : (
    <Stack spacing="xl">
      <Title level={2}>Einstellungen</Title>
      <Stack spacing="xl">
        <Tabs>
          <Tabs.List>
            {/*<Tabs.Tab label="Benachrichtigungen" key={'benachrichtigungen'} />*/}
            <Tabs.Tab
              label="Benutzende und Rollen"
              key={'benutzende-und-rollen'}
            />
            <Tabs.Tab
              label="FIT-Connect-Konfiguration"
              key={'fit-connect-konfiguration'}
            />
            <Tabs.Tab label="Datenmodelle" key={'datenmodelle'} />
            <Tabs.Tab label="BundID-Postfach" key={'bundid-postfach'} />
            <Tabs.Tab label="Logo / Wappen" key={'logo-wappen'} />
            <Tabs.Tab label="Footerlinks" key={'footerlinks'} />
          </Tabs.List>
          <Tabs.Panels>
            {/*<Tabs.Panel>*/}
            {/*  <Notifications />*/}
            {/*</Tabs.Panel>*/}
            <Tabs.Panel>
              <Toggled
                isEnabled={getToggle('SSO')}
                childrenWhenTrue={<UsersAndRolesSSO />}
                childrenWhenFalse={<UsersAndRoles />}
              />
            </Tabs.Panel>
            <Tabs.Panel>
              <FitConnectSettings />
            </Tabs.Panel>
            <Tabs.Panel>
              <DatamodelSettings />
            </Tabs.Panel>
            <Tabs.Panel>
              <BundIdSettings />
            </Tabs.Panel>
            <Tabs.Panel>
              <LogoSettings />
            </Tabs.Panel>
            <Tabs.Panel>
              <FooterlinksSettings />
            </Tabs.Panel>
          </Tabs.Panels>
        </Tabs>
      </Stack>
    </Stack>
  );
}
